var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { TranslateService } from '@ngx-translate/core';
import { COLORS } from 'app/shared/colors';
import { BackendService } from 'app/shared/services/backend.service';
import { UserService } from 'app/shared/services/user.service';
import { Subject } from 'rxjs';
export var UserNotificationType;
(function (UserNotificationType) {
    // The user gets a notification that the founder has removed him/her from the team
    UserNotificationType["USER_REMOVED"] = "userRemoved";
    // Members of the team get a notification when team is deleted
    UserNotificationType["TEAM_DELETED"] = "deleteTeam";
    // The founder gets a notification that a user left the team
    UserNotificationType["USER_LEFT_TEAM"] = "leaveTeam";
    // The founder cancels an invitation and the user gets a notification
    UserNotificationType["INVITATION_CANCEL"] = "cancelInvitation";
    // The founder gets a notification that a user has applied for the team
    UserNotificationType["APPLICATION_NEW"] = "applicationNew";
    // The user gets a notification that the founder declined the application
    UserNotificationType["APPLICATION_CANCEL"] = "applicationCancel";
    // The user gets a notification that the founder accepted the application
    UserNotificationType["APPLICATION_ACCEPT"] = "applicationAccept";
    // Every user gets a notification if his team is weekly winner team
    UserNotificationType["WEEKLY_WINNER"] = "weeklyWinner";
})(UserNotificationType || (UserNotificationType = {}));
export var UserNotificationActionType;
(function (UserNotificationActionType) {
    UserNotificationActionType["ACCEPT_APPLICATION"] = "acceptApplication";
    UserNotificationActionType["REJECT_APPLICATION"] = "rejectApplication";
    UserNotificationActionType["MANAGE_TEAM"] = "manageTeam";
    UserNotificationActionType["SELECT_TEAM"] = "selectTeam";
})(UserNotificationActionType || (UserNotificationActionType = {}));
var NotificationService = (function () {
    function NotificationService(translate, userService, backendService) {
        var _this = this;
        this.translate = translate;
        this.userService = userService;
        this.backendService = backendService;
        this.notificationQueue = [];
        this._notificationOptions = new Subject();
        this.notificationOptionsObservable = this._notificationOptions.asObservable();
        this.notificationWorker = null;
        this.currentUser = null;
        this.userService.currentUser.subscribe(function (user) {
            if (!user || user._id !== _this.currentUser) {
                clearInterval(_this.notificationWorker);
            }
            if (!user || _this.currentUser === user._id) {
                return;
            }
            _this.currentUser = user._id;
            _this.getNotificationsForUser(user._id);
            // Fetch new notifications every 2 minutes, make sure interval is cleared when user changes and in OnDestroy
            _this.notificationWorker = setInterval(function () { return _this.getNotificationsForUser(user._id); }, 120000);
        });
    }
    NotificationService.prototype.getNotificationsForUser = function (userID) {
        return __awaiter(this, void 0, void 0, function () {
            var notifications, _i, notifications_1, notification, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.backendService.get("notification/user/" + userID)];
                    case 1:
                        notifications = _a.sent();
                        if (!notifications) {
                            return [2 /*return*/];
                        }
                        for (_i = 0, notifications_1 = notifications; _i < notifications_1.length; _i++) {
                            notification = notifications_1[_i];
                            this.displayNotification(notification);
                        }
                        // Dismiss notifications so they do not appear again
                        if (notifications.length > 0) {
                            this.dismissNotifications(notifications[0].userID, notifications.map(function (notification) { return notification._id; })).then();
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    NotificationService.prototype.dismissNotifications = function (userID, notificationIds) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.backendService.post("notification/user/" + userID + "/dismiss", { notificationIds: notificationIds })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Adds a snackbar message to queue
     * @param {string} message         Message that should be displayed
     * @param {number} [duration=3000] Duration of message display (optional)
     * @param buttons Buttons that should be displayed in notification
     */
    NotificationService.prototype.add = function (message, duration, buttons) {
        if (duration === void 0) { duration = 3000; }
        if (buttons === void 0) { buttons = []; }
        var snackbarOptions = {
            message: message,
            visible: false,
            duration: isNaN(duration) || duration <= 0 ? 5000 : duration,
            color: COLORS.main.white.hex,
            buttons: buttons,
        };
        this.notificationQueue.push(snackbarOptions);
        if (this.notificationQueue.length === 1) {
            this.openNextNotification();
        }
    };
    /**
     * Display next item in queue
     */
    NotificationService.prototype.openNextNotification = function () {
        if (this.notificationQueue.length > 0) {
            this.notificationQueue[0]['visible'] = true;
            this._notificationOptions.next(this.notificationQueue[0]);
        }
    };
    /**
     * Dismiss message and trigger next item in queue
     */
    NotificationService.prototype.dismiss = function () {
        var _this = this;
        this.notificationQueue[0]['visible'] = false;
        this._notificationOptions.next(this.notificationQueue[0]);
        // Show next message after old one is hidden
        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
            // Remove first element of queue
            _this.notificationQueue.shift();
            _this.openNextNotification();
        }, 250);
    };
    NotificationService.prototype.displayNotification = function (notification) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (notification.type) {
                    // Displayed to the founder, when another user leaves the team
                    case UserNotificationType.USER_LEFT_TEAM: {
                        this.add(this.translate.instant('NOTIFICATION.text.userLeftTeam'), 20000, [
                            {
                                label: this.translate.instant('NOTIFICATION.action.manageTeam'),
                                style: 'primary',
                                action: { type: UserNotificationActionType.MANAGE_TEAM },
                            },
                        ]);
                        break;
                    }
                    // Displayed for founder, when a user applies for the team
                    case UserNotificationType.APPLICATION_NEW: {
                        this.add(this.translate.instant('NOTIFICATION.text.applicationNew', { user: notification.data.userName }), 20000, [
                            {
                                label: this.translate.instant('NOTIFICATION.action.acceptApplication'),
                                style: 'primary',
                                action: {
                                    type: UserNotificationActionType.ACCEPT_APPLICATION,
                                    userID: notification.data.userID,
                                    teamID: notification.data.teamID,
                                    challengeID: notification.data.challengeID,
                                },
                            },
                            {
                                label: this.translate.instant('NOTIFICATION.action.denyApplication'),
                                style: 'error',
                                action: {
                                    type: UserNotificationActionType.REJECT_APPLICATION,
                                    userID: notification.data.userID,
                                    teamID: notification.data.teamID,
                                    challengeID: notification.data.challengeID,
                                },
                            },
                        ]);
                        break;
                    }
                    case UserNotificationType.APPLICATION_CANCEL: {
                        this.add(this.translate.instant('NOTIFICATION.text.applicationCancelled', { team: notification.data.teamName }), 20000, [
                            {
                                label: this.translate.instant('NOTIFICATION.action.selectTeam'),
                                style: 'primary',
                                action: {
                                    type: UserNotificationActionType.SELECT_TEAM,
                                    challengeID: notification.data.challengeID,
                                },
                            },
                        ]);
                        break;
                    }
                    case UserNotificationType.APPLICATION_ACCEPT: {
                        this.add(this.translate.instant('NOTIFICATION.text.applicationAccepted', { team: notification.data.teamName }), 20000);
                        break;
                    }
                    case UserNotificationType.TEAM_DELETED: {
                        this.add(this.translate.instant('NOTIFICATION.text.teamDeleted', { team: notification.data.teamName }), 20000, [
                            {
                                label: this.translate.instant('NOTIFICATION.action.selectTeam'),
                                style: 'primary',
                                action: {
                                    type: UserNotificationActionType.SELECT_TEAM,
                                    challengeID: notification.data.challengeID,
                                },
                            },
                        ]);
                        break;
                    }
                    case UserNotificationType.USER_REMOVED: {
                        this.add(this.translate.instant('NOTIFICATION.text.userRemoved', { team: notification.data.teamName }), 20000, [
                            {
                                label: this.translate.instant('NOTIFICATION.action.selectTeam'),
                                style: 'primary',
                                action: {
                                    type: UserNotificationActionType.SELECT_TEAM,
                                    challengeID: notification.data.challengeID,
                                },
                            },
                        ]);
                        break;
                    }
                    case UserNotificationType.INVITATION_CANCEL: {
                        this.add(this.translate.instant('NOTIFICATION.text.invitationCancelled', { team: notification.data.teamName }), 20000, [
                            {
                                label: this.translate.instant('NOTIFICATION.action.selectTeam'),
                                style: 'primary',
                                action: {
                                    type: UserNotificationActionType.SELECT_TEAM,
                                    challengeID: notification.data.challengeID,
                                },
                            },
                        ]);
                        break;
                    }
                    case UserNotificationType.WEEKLY_WINNER: {
                        this.add(this.translate.instant('NOTIFICATION.text.weeklyWinner', { team: notification.data.teamName }), 20000);
                        break;
                    }
                    default: {
                        break;
                    }
                }
                return [2 /*return*/];
            });
        });
    };
    /**
     * On destroy cancel fetch notification job
     */
    NotificationService.prototype.ngOnDestroy = function () {
        if (this.notificationWorker) {
            clearInterval(this.notificationWorker);
        }
    };
    return NotificationService;
}());
export { NotificationService };



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/theme/components/user-notification/notification.service.ts.pre-build-optimizer.js